// Define IS_DEV global required by @axon-enterprise/i18n
(window as any).IS_DEV = process.env.NODE_ENV === 'development';

export {};

